import { render, staticRenderFns } from "./huodongdengjiqueren.vue?vue&type=template&id=b4300d06&scoped=true"
import script from "./huodongdengjiqueren.vue?vue&type=script&lang=js"
export * from "./huodongdengjiqueren.vue?vue&type=script&lang=js"
import style0 from "./huodongdengjiqueren.vue?vue&type=style&index=0&id=b4300d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4300d06",
  null
  
)

export default component.exports